import React from 'react'
import { Tabs } from '@/shared/ui'
import { getCurrentMonthInput, monthInputToMonthStartDate } from '../utils/month'
import RevshareMasterHeader from './RevshareMasterHeader'
import RevshareMasterSummaryTab from './RevshareMasterSummaryTab'
import RevshareParticipantsTab from './RevshareParticipantsTab'
import RevshareMonthConfigTab from './RevshareMonthConfigTab'

export default function RepassesMasterView() {
  const [tab, setTab] = React.useState<'resumo' | 'participantes' | 'config'>('resumo')
  const [month, setMonth] = React.useState<string>(() => getCurrentMonthInput())
  const [monthStartDate, setMonthStartDate] = React.useState<string>(() => monthInputToMonthStartDate(getCurrentMonthInput()))
  const [monthError, setMonthError] = React.useState<string | null>(null)
  const [refreshKey, setRefreshKey] = React.useState(0)

  React.useEffect(() => {
    try {
      setMonthStartDate(monthInputToMonthStartDate(month))
      setMonthError(null)
    } catch (e: any) {
      setMonthError(e?.message || 'Mes invalido')
    }
  }, [month])

  return (
    <div>
      <RevshareMasterHeader
        month={month}
        onMonthChange={setMonth}
        onRefresh={() => setRefreshKey((n) => n + 1)}
      />

      {monthError && <div className="mb-4 text-sm text-red-400">{monthError}</div>}

      <Tabs
        tabs={[
          { value: 'resumo', label: 'Resumo' },
          { value: 'participantes', label: 'Participantes' },
          { value: 'config', label: 'Configuracao' },
        ]}
        value={tab}
        onValueChange={(v) => setTab(v as any)}
        className="mb-6"
      />

      {tab === 'resumo' && !monthError && (
        <RevshareMasterSummaryTab monthStartDate={monthStartDate} refreshKey={refreshKey} />
      )}
      {tab === 'participantes' && (
        <RevshareParticipantsTab refreshKey={refreshKey} />
      )}
      {tab === 'config' && !monthError && (
        <RevshareMonthConfigTab monthStartDate={monthStartDate} refreshKey={refreshKey} />
      )}
    </div>
  )
}

